import * as React from 'react';
const SvgMailIcon = (props) => (
  <svg viewBox="0 0 26 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M24.52 1.377 13 10.962 1.48 1.377M25 17l-6-6M1 17l6-6"
      stroke="#fff"
      strokeWidth={2}
      strokeMiterlimit={10}
    />
    <rect x={1} y={1} width={24} height={16} rx={1} stroke="#fff" strokeWidth={2} />
  </svg>
);
export default SvgMailIcon;
